export const articleData: Record<string, any> = {
  'article-1': {
    title: '2026年世界杯预选赛亚洲区12强赛完整赛程公布',
    category: '足球',
    categorySlug: 'football',
    date: '2026-08-07',
    author: '开云体育编辑部',
    image: 'https://readdy.ai/api/search-image?query=Professional%20soccer%20world%20cup%20qualifier%20atmosphere%20in%20stadium%2C%20dramatic%20floodlights%2C%20national%20team%20jerseys%2C%20golden%20and%20crimson%20lighting%2C%20editorial%20sports%20photography%2C%20epic%20composition&width=1200&height=600&seq=article-detail-1&orientation=landscape',
    tags: ['世界杯', '预选赛', '亚洲区'],
    content: `
      <p>国际足联（FIFA）于今日正式公布了2026年世界杯亚洲区预选赛12强赛的完整赛程安排。本届12强赛将于2026年9月正式拉开帷幕，12支亚洲顶级球队将展开激烈角逐，争夺宝贵的世界杯决赛圈入场券。</p>
      
      <h2>赛程概览</h2>
      <p>12强赛共分为两个小组，每组6支球队进行主客场双循环赛制。每组前两名将直接晋级2026年世界杯决赛圈，两个小组的第三名将进行附加赛，胜者将参加洲际附加赛。</p>
      
      <p>A组球队包括：日本、澳大利亚、沙特阿拉伯、阿联酋、伊拉克、中国。B组球队包括：韩国、伊朗、卡塔尔、乌兹别克斯坦、约旦、阿曼。</p>
      
      <h2>中国队的征程</h2>
      <p>中国队在A组将面临严峻挑战。首场比赛将于9月5日客场挑战沙特阿拉伯，随后在9月10日主场迎战阿联酋。对于中国队来说，每一场比赛都至关重要，尤其是在主场的表现将直接决定出线前景。</p>
      
      <p>主教练在赛前发布会上表示："我们清楚面临的挑战，但球队已经做好了充分准备。每一位球员都将全力以赴，为中国足球争取荣誉。"</p>
      
      <h2>竞猜看点</h2>
      <p>对于关注12强赛的球迷来说，这不仅是一场场精彩的比赛，更是参与体育竞猜的绝佳机会。开云体育将全程提供各场比赛的实时赔率，让球迷在观赛的同时享受竞猜的乐趣。</p>
      
      <p>建议球迷在参与竞猜时注意以下几点：关注球队近期状态、了解伤病情况、参考历史交锋记录。理性投注，享受比赛。</p>
    `,
    relatedArticles: ['article-2', 'article-4', 'article-5'],
  },
  'article-2': {
    title: 'NBA夏季转会窗口：湖人完成重磅交易，詹姆斯搭档再升级',
    category: '篮球',
    categorySlug: 'basketball',
    date: '2026-08-06',
    author: '开云体育编辑部',
    image: 'https://readdy.ai/api/search-image?query=Professional%20NBA%20basketball%20trade%20announcement%20scene%2C%20dramatic%20arena%20lighting%2C%20basketball%20player%20silhouette%2C%20golden%20and%20deep%20red%20tones%2C%20sports%20journalism%20photography%2C%20clean%20composition&width=1200&height=600&seq=article-detail-2&orientation=landscape',
    tags: ['NBA', '转会', '湖人'],
    content: `
      <p>NBA夏季转会市场再掀波澜！洛杉矶湖人队通过一笔三方交易成功引进了全明星级别的锋线球员，为勒布朗·詹姆斯找到了新的强力搭档。这笔交易涉及湖人队、公牛队和步行者队三方。</p>
      
      <h2>交易详情</h2>
      <p>湖人队送出了三个未来首轮选秀权和两名年轻球员，换来了公牛队的明星得分后卫和步行者队的防守悍将。这笔交易完成后，湖人队的阵容深度得到了显著提升，新赛季的竞争力将大幅增强。</p>
      
      <h2>新阵容展望</h2>
      <p>新阵容的核心将由詹姆斯、戴维斯和新加入的明星后卫组成。加上原有的角色球员，湖人队在新赛季的攻防两端都将拥有更多选择。分析人士普遍认为，湖人队已经重新成为西部冠军的有力竞争者。</p>
      
      <h2>对新赛季的影响</h2>
      <p>这笔交易不仅改变了湖人队的实力格局，也影响了整个西部的竞争态势。随着湖人队的补强，勇士、掘金等强队也将面临更大的压力。新赛季的西部分区竞争将更加激烈。</p>
    `,
    relatedArticles: ['article-1', 'article-4', 'article-6'],
  },
  'article-3': {
    title: '英雄联盟S16全球总决赛赛制改革：新增瑞士轮赛制',
    category: '电竞',
    categorySlug: 'esports',
    date: '2026-08-05',
    author: '开云体育编辑部',
    image: 'https://readdy.ai/api/search-image?query=Professional%20esports%20league%20of%20legends%20championship%20stage%2C%20dramatic%20neon%20lighting%2C%20large%20LED%20screens%2C%20gaming%20arena%20atmosphere%2C%20dark%20background%20with%20colorful%20highlights%2C%20competitive%20gaming%20event&width=1200&height=600&seq=article-detail-3&orientation=landscape',
    tags: ['英雄联盟', 'S16', '赛制改革'],
    content: `
      <p>拳头游戏（Riot Games）官方宣布，英雄联盟S16全球总决赛将引入瑞士轮赛制，这一重大改革将从入围赛阶段开始实施。这是英雄联盟电竞赛事历史上最具颠覆性的赛制变革之一。</p>
      
      <h2>瑞士轮赛制详解</h2>
      <p>瑞士轮赛制是一种更加公平的锦标赛赛制：所有队伍首先随机配对进行第一轮比赛。之后，战绩相同的队伍之间进行配对，胜场数相同的队伍互相交手，败场数相同的队伍也互相交手。任何取得3胜的队伍晋级，任何遭受3败的队伍淘汰。</p>
      
      <h2>改革的意义</h2>
      <p>相比传统的小组赛赛制，瑞士轮能够有效避免"死亡之组"的不公平情况，确保每支队伍都有更多展示实力的机会。同时，每一场比赛都至关重要，增加了赛事的观赏性和悬念。</p>
      
      <h2>对各赛区的影响</h2>
      <p>对于LPL和LCK等实力较强的赛区，瑞士轮意味着更多的容错空间。而对于外卡赛区来说，瑞士轮提供了更多与强队交手学习的机会。各方对于这次改革普遍持积极态度。</p>
    `,
    relatedArticles: ['article-5', 'article-6', 'article-2'],
  },
  'article-4': {
    title: '英超新赛季前瞻：六强格局巨变，谁能登顶？',
    category: '足球',
    categorySlug: 'football',
    date: '2026-08-04',
    author: '开云体育编辑部',
    image: 'https://readdy.ai/api/search-image?query=English%20premier%20league%20stadium%20panoramic%20view%20during%20match%20day%2C%20vibrant%20green%20pitch%2C%20dramatic%20atmosphere%2C%20golden%20afternoon%20sunlight%2C%20editorial%20sports%20journalism%2C%20professional%20composition&width=1200&height=600&seq=article-detail-4&orientation=landscape',
    tags: ['英超', '赛季前瞻', '六强'],
    content: `
      <p>2026-2027赛季英超联赛即将在本周末拉开大幕。在经历了一个充满惊喜的夏季转会窗口之后，传统六强的阵容发生了显著变化。让我们一起来解析新赛季各支球队的前景。</p>
      
      <h2>曼城：卫冕冠军的挑战</h2>
      <p>作为上赛季的冠军，曼城在新赛季依然保持着强大的竞争力。球队在夏季转会窗进行了针对性的补强，引进了两名年轻有为的中场球员。瓜迪奥拉的战术体系依然是英超最具统治力的。</p>
      
      <h2>阿森纳：青年军的崛起</h2>
      <p>阿森纳在上赛季表现出色，新赛季他们保留了核心阵容并进行了有效补强。年轻球员的持续成长为球队注入了新的活力，阿尔特塔的战术理念正在逐步深入人心。</p>
      
      <h2>利物浦：克洛普时代的新篇章</h2>
      <p>利物浦在经历阵容调整后，新赛季展现出焕然一新的面貌。中场重组后的红军在季前热身赛中表现抢眼，有望重返争冠行列。</p>
    `,
    relatedArticles: ['article-1', 'article-5', 'article-6'],
  },
  'article-5': {
    title: '开云体育荣获"2026年度最佳在线体育平台"大奖',
    category: '平台动态',
    categorySlug: 'news',
    date: '2026-08-03',
    author: '开云体育编辑部',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20professional%20award%20ceremony%20stage%20with%20golden%20trophy%2C%20warm%20spotlight%2C%20celebration%20atmosphere%2C%20dark%20sophisticated%20background%2C%20event%20photography%2C%20prestigious%20composition&width=1200&height=600&seq=article-detail-5&orientation=landscape',
    tags: ['开云体育', '获奖', '平台动态'],
    content: `
      <p>在刚刚结束的2026年国际博彩博览会（iGaming Expo 2026）上，kaiyun.com开云体育凭借其卓越的用户体验、创新的技术架构和严格的安全保障体系，荣获"2026年度最佳在线体育平台"大奖。</p>
      
      <h2>评选标准</h2>
      <p>本次评选由国际博彩行业协会组织，评审团由行业专家、技术顾问和用户代表组成。评选标准涵盖了平台安全性、用户体验、产品创新、客户服务、支付便捷性等多个维度。</p>
      
      <h2>开云体育的优势</h2>
      <p>kaiyun.com能够在激烈的竞争中脱颖而出，主要得益于以下几个方面：业界领先的数据加密技术保障用户安全、7x24小时全天候客服支持、多渠道快速提现系统、以及覆盖全球128+个国家的赛事资源。</p>
      
      <h2>未来展望</h2>
      <p>开云体育CEO在获奖感言中表示："这个奖项是对我们团队多年努力的肯定。未来我们将继续以用户为中心，不断优化产品体验，为全球体育爱好者提供更优质的服务。"</p>
    `,
    relatedArticles: ['article-6', 'article-3', 'article-4'],
  },
  'article-6': {
    title: '网球大满贯赛事竞猜攻略：从入门到精通的五大技巧',
    category: '攻略',
    categorySlug: 'news',
    date: '2026-08-02',
    author: '开云体育编辑部',
    image: 'https://readdy.ai/api/search-image?query=Professional%20tennis%20grand%20slam%20court%20with%20golden%20hour%20sunlight%2C%20tennis%20ball%20closeup%20in%20motion%2C%20athletic%20aesthetics%2C%20editorial%20sports%20photography%2C%20warm%20natural%20lighting%2C%20clean%20composition&width=1200&height=600&seq=article-detail-6&orientation=landscape',
    tags: ['网球', '竞猜攻略', '大满贯'],
    content: `
      <p>网球大满贯赛事是体育竞猜中最受欢迎的项目之一。无论你是刚接触竞猜的新手还是经验丰富的老手，掌握正确的分析方法都能显著提高你的竞猜胜率。以下是五大实用技巧：</p>
      
      <h2>技巧一：了解场地类型对比赛的影响</h2>
      <p>网球四大满贯分别在不同的场地上进行：澳网（硬地）、法网（红土）、温网（草地）、美网（硬地）。不同场地对球员的发挥有着截然不同的影响。例如，纳达尔在红土场上具有绝对统治力，而在草地上则相对较弱。</p>
      
      <h2>技巧二：关注球员近期状态与伤病</h2>
      <p>球员的近期状态是判断比赛走向的重要指标。关注球员在最近几场比赛的表现、是否有伤病困扰、以及体能状态。这些因素往往比历史排名更能反映真实的竞技水平。</p>
      
      <h2>技巧三：分析历史交锋记录</h2>
      <p>两个球员之间的历史交锋记录蕴含着丰富的信息。有些球员之间存在"克星"关系——即使排名较低，也可能在特定对手面前表现出色。深入分析这些数据可以帮助你做出更准确的判断。</p>
      
      <h2>技巧四：利用实时赔率变化</h2>
      <p>赔率的变化反映了市场对比赛的预期。在比赛开始前后密切关注赔率走势，可以帮助你发现价值投注的机会。开云体育提供实时赔率更新，确保你不错过任何机会。</p>
      
      <h2>技巧五：合理管理资金</h2>
      <p>无论分析多么深入，竞猜都存在不确定性。合理设置每次投注的金额，不要追涨杀跌，保持冷静的投资心态。理性参与，享受竞猜的过程本身。</p>
    `,
    relatedArticles: ['article-1', 'article-3', 'article-5'],
  },
  'register-guide': {
    title: 'kaiyun.com 新用户注册完整教程',
    category: '新手指南',
    categorySlug: 'news',
    date: '2026-07-20',
    author: '开云体育客服团队',
    image: 'https://readdy.ai/api/search-image?query=Modern%20clean%20smartphone%20registration%20screen%20with%20sports%20theme%2C%20warm%20lighting%2C%20professional%20minimal%20design%2C%20digital%20interface%2C%20clean%20composition%2C%20soft%20shadows&width=1200&height=600&seq=article-guide-register&orientation=landscape',
    tags: ['新手指南', '注册教程'],
    content: `
      <p>欢迎来到开云体育！本教程将手把手教你如何快速完成注册，开启你的体育竞猜之旅。整个过程只需1-2分钟。</p>
      
      <h2>第一步：访问官网</h2>
      <p>打开浏览器，访问 kaiyun.com 官方网站。点击页面右上角的"立即注册"按钮进入注册页面。</p>
      
      <h2>第二步：填写基本信息</h2>
      <p>在注册页面输入你的手机号码或电子邮箱地址，设置一个安全强度高的密码（建议包含大小写字母、数字和特殊字符）。</p>
      
      <h2>第三步：完成验证</h2>
      <p>系统将向你的手机或邮箱发送验证码，输入验证码完成身份验证。请确保你填写的联系方式准确无误。</p>
      
      <h2>第四步：设置账户信息</h2>
      <p>验证通过后，设置你的用户名和偏好货币。请使用真实信息，这将影响后续的提现流程。</p>
    `,
    relatedArticles: ['deposit-guide', 'withdraw-guide'],
  },
  'deposit-guide': {
    title: 'kaiyun.com 充值指南：多种方式轻松入金',
    category: '新手指南',
    categorySlug: 'news',
    date: '2026-07-18',
    author: '开云体育客服团队',
    image: 'https://readdy.ai/api/search-image?query=Modern%20digital%20payment%20concept%20with%20smartphone%20and%20credit%20cards%2C%20warm%20golden%20lighting%2C%20clean%20minimal%20design%2C%20professional%20finance%20photography%2C%20soft%20background&width=1200&height=600&seq=article-guide-deposit&orientation=landscape',
    tags: ['新手指南', '充值教程'],
    content: `
      <p>开云体育支持多种便捷的充值方式，确保你能够快速、安全地完成资金充值。以下是详细的操作指南。</p>
      
      <h2>支持的充值方式</h2>
      <p>我们支持：银行卡转账、微信支付、支付宝、USDT（加密货币）、以及多种主流电子钱包。所有充值方式均实时到账，且不收取任何手续费。</p>
      
      <h2>充值步骤</h2>
      <p>登录账户后，点击"充值"按钮，选择你偏好的支付方式，输入充值金额，按照页面提示完成支付即可。资金将立即到达你的账户。</p>
      
      <h2>安全提示</h2>
      <p>请务必通过官方渠道进行充值，不要相信任何第三方代充服务。如遇到任何问题，请立即联系在线客服。</p>
    `,
    relatedArticles: ['register-guide', 'withdraw-guide'],
  },
  'withdraw-guide': {
    title: 'kaiyun.com 提现说明：快速安全到账',
    category: '新手指南',
    categorySlug: 'news',
    date: '2026-07-15',
    author: '开云体育客服团队',
    image: 'https://readdy.ai/api/search-image?query=Modern%20secure%20financial%20transaction%20concept%2C%20digital%20banking%20interface%2C%20warm%20golden%20lighting%2C%20professional%20finance%20photography%2C%20clean%20minimal%20composition%2C%20trust%20and%20security%20theme&width=1200&height=600&seq=article-guide-withdraw&orientation=landscape',
    tags: ['新手指南', '提现教程'],
    content: `
      <p>开云体育以提现速度快、到账稳定著称。以下是详细的提现操作说明和注意事项。</p>
      
      <h2>提现流程</h2>
      <p>登录账户后，进入"提现"页面，选择提现方式，输入提现金额，确认信息无误后提交申请。我们的系统将在最短时间内处理你的提现请求。</p>
      
      <h2>到账时间</h2>
      <p>小额提现（1万元以下）：审核通过后秒到账。大额提现：通常在30分钟内到账。我们承诺全网最快的提现处理速度，让你的资金流转无忧。</p>
      
      <h2>注意事项</h2>
      <p>为确保资金安全，提现前需要完成实名认证。提现金额需满足最低提现额度要求。如有疑问，请随时联系24小时在线客服。</p>
    `,
    relatedArticles: ['register-guide', 'deposit-guide'],
  },
};

export function getArticleById(id: string) {
  return articleData[id] || null;
}